import { Component, OnInit, ViewChild, Inject, OnDestroy } from '@angular/core';
import { ContatoAnexo } from '../../models/contato-anexo';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MatPaginator, MatDialog, MatDialogRef, MAT_DIALOG_DATA, PageEvent } from '@angular/material';
import { ContatoAnexoService } from 'src/app/services/contato-anexo.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/services/global.service';
import { ArquivoService } from 'src/app/services/arquivo.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { Filtro } from 'src/app/models/filtro';
import { CadastrarContatoAnexoModalComponent } from './cadastrar-contato-anexo-modal/cadastrar-contato-anexo-modal.component';
import { TipoArquivo } from 'src/app/models/enum';
import swal from 'sweetalert2';
import { PaginatorService } from 'src/app/services/paginator.service';
import { Subscription } from 'rxjs';

// jquery
declare const $: any;

@Component({
  selector: 'app-contato-anexo-modal',
  templateUrl: './contato-anexo-modal.component.html',
  styleUrls: ['./contato-anexo-modal.component.scss']
})
export class ContatoAnexoModalComponent implements OnInit, OnDestroy {
  idContato: number;
  contatoAnexosFiltrados: ContatoAnexo[] = [];
  carregando = true;
  campoOrdenacao = 'descricao';
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  filtroNome: Filtro = { Propriedade: 'nome', Valor: '' };
  filtros: Filtro[] = [this.filtroNome];
  public config: PerfectScrollbarConfigInterface = {};
  integrador = false;
  statusSelecionado;

  origem = 0;

  private subscriptionAnexos$: Subscription;
  private subscriptionsAnexoLog$: Subscription[] = [];

  @ViewChild('paginatorAnexo', { static: false }) paginator: MatPaginator;

  constructor(private contatoAnexoService: ContatoAnexoService, private utilitarioService: UtilitarioService,
    private router: Router, private globalService: GlobalService, public dialog: MatDialog, private arquivoService: ArquivoService,
    private carregandoService: CarregandoService, private notificacaoService: NotificacaoService, private paginatorService: PaginatorService,
    public dialogRef: MatDialogRef<ContatoAnexoModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  async ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.integrador = await this.globalService.integrador();
    this.editavel = this.data.podeEditar;
    this.idContato = this.data.idContato;
    this.statusSelecionado = this.data.statusSelecionado;

    this.buscarContatoAnexos();
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra() {
    this.buscarContatoAnexos();
    this.paginator.firstPage();
  }

  buscarContatoAnexos() {
    this.carregandoService.mostra('buscaContatoAnexos');
    this.carregando = true;

    this.destroySubscriptionAnexos();
    this.destroySubscriptionAnexoLog();
    this.contatoAnexosFiltrados = [];

    this.subscriptionAnexos$ = this.contatoAnexoService.consultarContatoAnexosComPaginacao(this.idContato, this.filtroNome.Valor, this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc', this.origem).subscribe(dados => {
        this.contatoAnexosFiltrados = dados.itens;

        if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
          this.itensPorPagina = 10;
        }

        this.paginacao.total = dados.total;

        this.contatoAnexosFiltrados.forEach(p => {
          this.buscarLogs(p);
        });

        this.carregando = false;
        this.carregandoService.esconde('buscaContatoAnexos');
      }, (erro) => {
        this.carregandoService.esconde('buscaContatoAnexos');
        this.notificacaoService.erro(erro);
      });
  }

  buscarLogs(anexo: ContatoAnexo) {

    this.subscriptionsAnexoLog$.push(this.contatoAnexoService.consultarDadosLog(anexo.id).subscribe(dados => {

      anexo.dataHora = dados.dataHora;
      anexo.dataHoraExc = dados.dataHoraExc;
      anexo.nomeUsuario = dados.nomeUsuario;
      anexo.nomeUsuarioExc = dados.nomeUsuarioExc;

    }, (erro) => {
      this.notificacaoService.erro(erro);
    }));
  }

  novoContatoAnexo() {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(CadastrarContatoAnexoModalComponent, {
      width: largura > 830 ? '800px' : (($('body').width()).toString() + 'px'),
      data: {
        idContato: this.idContato,
        statusSelecionado: this.statusSelecionado
      },
      panelClass: 'modal-card',
      maxHeight: '90vh'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.buscarContatoAnexos();
      }
    });
  }

  editarContatoAnexo(contatoAnexo: ContatoAnexo) {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(CadastrarContatoAnexoModalComponent, {
      width: largura > 830 ? '800px' : (($('body').width()).toString() + 'px'),
      data: {
        id: contatoAnexo.id,
        idContato: this.idContato,
        statusSelecionado: this.statusSelecionado
      },
      panelClass: 'modal-card',
      maxHeight: '90vh'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.buscarContatoAnexos();
      }
    });
  }

  baixarArquivo(anexo: ContatoAnexo) {
    this.carregandoService.mostra('baixarArquivo');
    this.arquivoService.baixarArquivo(anexo.id, TipoArquivo.Integrador).subscribe(arq => {
      this.utilitarioService.saveBlob(arq, anexo.arquivo);
      this.carregandoService.esconde('baixarArquivo');
    }, (erro) => {
      this.carregandoService.esconde('baixarArquivo');
      this.notificacaoService.erro(erro);
    });
  }

  visualizarArquivo(anexo: ContatoAnexo) {
    this.carregandoService.mostra('visualizarArquivo');
    this.arquivoService.baixarArquivo(anexo.id, TipoArquivo.Integrador).subscribe(arq => {
      if (this.utilitarioService.ePDF(anexo.arquivo)) {
        this.utilitarioService.openBlobModal(arq, anexo.arquivo);
      } else if (this.utilitarioService.eImagem(anexo.arquivo)) {
        this.utilitarioService.mostrarImagemBlob(arq, anexo.arquivo);
      } else {
        this.utilitarioService.saveBlob(arq, anexo.arquivo);
      }
      this.carregandoService.esconde('visualizarArquivo');
    }, (erro) => {
      this.carregandoService.esconde('visualizarArquivo');
      this.notificacaoService.erro(erro);
    });
  }

  excluirContatoAnexo(contatoAnexo: ContatoAnexo) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir o Anexo?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluiAnexo');
        this.contatoAnexoService.excluir(contatoAnexo.id).subscribe(resp => {
          this.notificacaoService.sucesso('Anexo excluído com sucesso!!!');
          this.carregandoService.esconde('excluiAnexo');
          this.filtra();
        }, (erro) => {
          this.carregandoService.esconde('excluiAnexo');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarContatoAnexos();
  }

  destroySubscriptionAnexos() {
    if (this.subscriptionAnexos$ !== null && this.subscriptionAnexos$ !== undefined) {
      this.subscriptionAnexos$.unsubscribe();
      this.subscriptionAnexos$ = undefined;
    }
  }

  destroySubscriptionAnexoLog() {
    if (this.subscriptionsAnexoLog$ !== null && this.subscriptionsAnexoLog$ !== undefined) {
      this.subscriptionsAnexoLog$.forEach(s => {
        if (s !== null && s !== undefined) {
          s.unsubscribe();
          s = undefined;
        }
      });

      this.subscriptionsAnexoLog$ = [];
    }
  }

  ngOnDestroy(): void {

    this.destroySubscriptionAnexos();
    this.destroySubscriptionAnexoLog();
  }

  fechar() {
    this.dialogRef.close();
  }
}
